<script setup lang="ts">
  import { X as XIcon } from 'lucide-vue-next'

  const emit = defineEmits<{
    (e: 'click'): void,
  }>()
</script>

<template>
  <div class="absolute right-2 top-3 lg:right-4 lg:top-5">
    <button
      class="flex items-center justify-center size-8 rounded-sm text-gray-500 hover:bg-gray-100"
      @click="emit('click')">
      <x-icon class="size-4 text-red-500" />
    </button>
  </div>
</template>
